var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"md:px-4 md:max-w-5xl w-full md:mx-auto"},[_c('a-text',{staticClass:"mb-6",attrs:{"tag":"h1"}},[_vm._v(" Olá! Informe os dados abaixo para consultar a viabilidade do plano escolhido :) ")]),_c('form-consulta-cobertura',{staticClass:"grid grid-cols-1 md:grid-cols-3 md:col-gap-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }